(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-wf-tabs]').forEach(function (group, groupIndex) {
      if (group.dataset.wfReady === 'true') return;
      group.dataset.wfReady = 'true';

      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-wf-tab]'));
      var panels = Array.prototype.slice.call(group.querySelectorAll('[data-wf-panel]'));

      function selectTab(tab) {
        tabs.forEach(function (item) {
          var active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.wfPanel === tab.dataset.wfTab;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      tabs.forEach(function (tab, tabIndex) {
        var target = panels.find(function (panel) { return panel.dataset.wfPanel === tab.dataset.wfTab; });
        var tabId = tab.id || 'wf-tab-' + groupIndex + '-' + tabIndex;
        var panelId = target && (target.id || 'wf-panel-' + groupIndex + '-' + tabIndex);
        tab.id = tabId;
        tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
        if (target) {
          target.id = panelId;
          target.setAttribute('role', 'tabpanel');
          target.setAttribute('aria-labelledby', tabId);
          tab.setAttribute('aria-controls', panelId);
          target.hidden = tab.getAttribute('aria-selected') !== 'true';
        }

        tab.addEventListener('click', function () { selectTab(tab); });
        tab.addEventListener('keydown', function (event) {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
          event.preventDefault();
          var nextIndex = tabs.indexOf(tab);
          if (event.key === 'ArrowRight') nextIndex = (nextIndex + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (nextIndex - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          tabs[nextIndex].focus();
          selectTab(tabs[nextIndex]);
        });
      });
    });
  }

  function initHeader(root) {
    var header = root.querySelector('[data-wf-header]');
    if (!header || header.dataset.wfReady === 'true') return;
    header.dataset.wfReady = 'true';
    var progress = header.querySelector('[data-wf-scroll-progress]');
    var update = function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      header.classList.toggle('is-scrolled', scrollTop > 24);
      if (progress) progress.style.transform = 'scaleX(' + Math.min(1, scrollTop / scrollable) + ')';
    };
    update();
    window.addEventListener('scroll', update, { passive: true });

    document.addEventListener('click', function (event) {
      header.querySelectorAll('.wf-nav__group[open]').forEach(function (details) {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') header.querySelectorAll('.wf-nav__group[open]').forEach(function (details) { details.removeAttribute('open'); });
    });
  }

  function initHeroMotion(root) {
    var visual = root.querySelector('[data-wf-hero-visual]');
    if (!visual || visual.dataset.wfReady === 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(pointer: fine)').matches) return;
    visual.dataset.wfReady = 'true';
    visual.addEventListener('pointermove', function (event) {
      var rect = visual.getBoundingClientRect();
      visual.style.setProperty('--wf-hero-x', ((event.clientX - rect.left) / rect.width - 0.5).toFixed(3));
      visual.style.setProperty('--wf-hero-y', ((event.clientY - rect.top) / rect.height - 0.5).toFixed(3));
    }, { passive: true });
    visual.addEventListener('pointerleave', function () {
      visual.style.setProperty('--wf-hero-x', 0);
      visual.style.setProperty('--wf-hero-y', 0);
    });
  }

  function initRevenue(root) {
    var calculator = root.querySelector('[data-wf-roi]');
    if (!calculator) return;
    var traffic = calculator.querySelector('[data-wf-traffic]');
    var conversion = calculator.querySelector('[data-wf-conversion]');
    var ticket = calculator.querySelector('[data-wf-ticket]');
    var days = calculator.querySelector('[data-wf-days]');
    var output = calculator.querySelector('[data-wf-output]');
    function calculate() {
      var total = (Number(traffic.value) || 0) * ((Number(conversion.value) || 0) / 100) * (Number(ticket.value) || 0) * (Number(days.value) || 0);
      output.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(total);
    }
    [traffic, conversion, ticket, days].forEach(function (input) {
      input.addEventListener('input', calculate);
    });
    calculate();
  }

  function initConfigurator(root) {
    var configurator = root.querySelector('[data-wf-configurator]');
    if (!configurator) return;
    var selected = {};
    configurator.querySelectorAll('[data-wf-chip]').forEach(function (chip) {
      if (chip.classList.contains('is-on')) selected[chip.dataset.wfGroup] = chip.textContent.trim();
      chip.addEventListener('click', function () {
        var group = chip.dataset.wfGroup;
        configurator.querySelectorAll('[data-wf-group="' + group + '"]').forEach(function (item) {
          item.classList.remove('is-on');
        });
        chip.classList.add('is-on');
        selected[group] = chip.textContent.trim();
        var summary = configurator.querySelector('[data-wf-config-summary]');
        if (summary) summary.textContent = Object.keys(selected).map(function (key) { return selected[key]; }).join(' / ');
      });
    });
  }

  function initMobileMenu(root) {
    var toggle = root.querySelector('[data-wf-menu-toggle]');
    var menu = root.querySelector('[data-wf-mobile-nav]');
    if (!toggle || !menu || menu.dataset.wfReady === 'true') return;
    menu.dataset.wfReady = 'true';

    var previousFocus = null;

    function focusableItems() {
      return Array.prototype.slice.call(menu.querySelectorAll('a[href], button:not([disabled])'));
    }

    function setOpen(open, returnFocus) {
      if (open) previousFocus = document.activeElement;
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      document.documentElement.classList.toggle('wf-menu-open', open);
      if (open) {
        window.requestAnimationFrame(function () {
          var items = focusableItems();
          if (items.length) items[0].focus();
        });
      } else if (returnFocus) {
        (previousFocus && previousFocus.focus ? previousFocus : toggle).focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-open'), false);
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        setOpen(false, true);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusableItems();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (menu.classList.contains('is-open') && !root.contains(event.target)) setOpen(false, false);
    });
  }

  function initActiveNavigation(root) {
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    root.querySelectorAll('.wf-nav a[href], .wf-mobile-nav a[href], .wf-footer a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || url.hash) return;
      var linkPath = url.pathname.replace(/\/$/, '') || '/';
      if (linkPath !== currentPath) return;
      link.setAttribute('aria-current', 'page');
      var group = link.closest('.wf-nav__group');
      var summary = group && group.querySelector(':scope > summary');
      if (summary) summary.classList.add('is-current');
    });
  }

  function initReveal(root) {
    var nodes = root.querySelectorAll('.wf-reveal');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    nodes.forEach(function (node, index) {
      node.style.setProperty('--wf-reveal-delay', Math.min(index % 3, 2) * 90 + 'ms');
      observer.observe(node);
    });
  }

  function initFloatingTools(root) {
    var tools = root.querySelector('[data-wf-floating-tools]');
    if (!tools || tools.dataset.wfReady === 'true') return;
    tools.dataset.wfReady = 'true';
    var top = tools.querySelector('[data-wf-top]');
    var update = function () { tools.classList.toggle('is-visible', window.scrollY > 420); };
    if (top) top.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initEcomSendAutoPopup() {
    if (document.documentElement.dataset.wfEcomsendAutoPopup === 'ready') return;
    document.documentElement.dataset.wfEcomsendAutoPopup = 'ready';

    var popupId = 335477;
    var canceled = false;
    var attempts = 0;
    var maxAttempts = 60;

    try {
      window.sessionStorage.removeItem('close_widget_modal' + popupId);
      window.sessionStorage.removeItem('pp_already_show' + popupId);
    } catch (error) {}

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('.ecomsend__Popover__Widget__CustomContainer, .react-responsive-modal-root')) {
        canceled = true;
      }
    }, true);

    var openNativePopup = function () {
      if (canceled || document.querySelector('.react-responsive-modal-root')) return;

      var trigger = document.querySelector('.ecomsend__Popover__Widget__Text')
        || document.querySelector('.ecomsend__Popover__Widget__CustomContainer');

      if (trigger) {
        canceled = true;
        trigger.click();
        return;
      }

      var actions = window.EcomSendApps && window.EcomSendApps.actions;
      var config = null;
      try {
        config = actions && typeof actions.getTargetPopupConfig === 'function'
          ? actions.getTargetPopupConfig(popupId)
          : null;
      } catch (error) {}

      if (actions && config && typeof actions.showModal === 'function') {
        try {
          canceled = true;
          actions.popupQuotaExhausted = false;
          actions.showModal(true, false, popupId);
          window.setTimeout(function () {
            if (!document.querySelector('.react-responsive-modal-root')) {
              canceled = false;
              openNativePopup();
            }
          }, 350);
          return;
        } catch (error) {
          canceled = false;
        }
      }

      if (actions && config && typeof actions.showWidget === 'function') {
        try { actions.showWidget(popupId); } catch (error) {}
      }

      attempts += 1;
      if (attempts < maxAttempts) window.setTimeout(openNativePopup, 250);
    };

    window.setTimeout(openNativePopup, 5000);
  }

  function initMediaGallery(root) {
    root.querySelectorAll('[data-wf-media-gallery]').forEach(function (gallery) {
      if (gallery.dataset.wfReady === 'true') return;
      gallery.dataset.wfReady = 'true';
      var rail = gallery.querySelector('[data-wf-media-rail]');
      var previous = gallery.querySelector('[data-wf-gallery-prev]');
      var next = gallery.querySelector('[data-wf-gallery-next]');
      if (!rail) return;
      var move = function (direction) {
        var card = rail.querySelector('.wf-media-card');
        var distance = card ? card.getBoundingClientRect().width + 16 : 320;
        rail.scrollBy({
          left: distance * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
    });
  }

  function initResourceExplorer(root) {
    root.querySelectorAll('[data-wf-resource-explorer]').forEach(function (explorer) {
      if (explorer.dataset.wfReady === 'true') return;
      explorer.dataset.wfReady = 'true';
      var buttons = explorer.querySelectorAll('[data-wf-resource-filter]');
      var cards = explorer.querySelectorAll('[data-wf-resource-card]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.dataset.wfResourceFilter;
          buttons.forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          cards.forEach(function (card) {
            card.hidden = filter !== 'all' && card.dataset.wfResourceCard !== filter;
          });
        });
      });
    });
  }

  function initMachineFormatSelect(root) {
    var labels = root.querySelectorAll('.wf-contact-card label');
    labels.forEach(function (label) {
      if (label.textContent.trim().replace(/\s*\*$/, '').toLowerCase() !== 'company') return;

      var field = label.closest('.form-crm--input-block') || label.parentElement;
      if (!field || field.dataset.wfMachineFormat === 'true') return;

      var input = field.querySelector('input:not([type="hidden"])');
      if (!input) return;

      field.dataset.wfMachineFormat = 'true';
      label.textContent = 'Machine format of interest';

      var select = document.createElement('select');
      select.className = 'wf-machine-format-select';
      select.setAttribute('aria-label', 'Machine format of interest');

      [
        ['', 'Select a machine format'],
        ['Indoor Refrigerated Retail', 'Indoor Refrigerated Retail'],
        ['Outdoor & Pickup Hubs', 'Outdoor & Pickup Hubs'],
        ['Modular Flower Lockers', 'Modular Flower Lockers'],
        ['Flower + Gifts Retail', 'Flower + Gifts Retail'],
        ['Please recommend a suitable format', 'Please recommend a suitable format']
      ].forEach(function (item) {
        var option = document.createElement('option');
        option.value = item[0];
        option.textContent = item[1];
        if (!item[0]) option.disabled = true;
        select.appendChild(option);
      });

      if (input.value) {
        var matchingOption = Array.prototype.some.call(select.options, function (option) {
          return option.value === input.value;
        });
        if (matchingOption) select.value = input.value;
      }

      select.required = input.required;
      select.addEventListener('change', function () {
        var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        setter.call(input, select.value);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.classList.add('wf-machine-format-source');
      input.setAttribute('aria-hidden', 'true');
      input.tabIndex = -1;
      input.insertAdjacentElement('afterend', select);

      var formRoot = field.closest('.form-crm-root') || field.parentElement;
      if (formRoot) {
        var countryLabel = Array.prototype.find.call(formRoot.querySelectorAll('label'), function (item) {
          return item.textContent.trim().replace(/\s*\*$/, '').toLowerCase() === 'country';
        });
        var countryField = countryLabel && (countryLabel.closest('.form-crm--input-block') || countryLabel.parentElement);
        if (countryField && countryField !== field) countryField.insertAdjacentElement('afterend', field);
      }
    });
  }

  function observeFormCrm() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          initMachineFormatSelect(node.matches('.wf-contact-card') ? node : document);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initFaqSearch(root) {
    root.querySelectorAll('[data-wf-faq]').forEach(function (faq) {
      if (faq.dataset.wfReady === 'true') return;
      faq.dataset.wfReady = 'true';
      var input = faq.querySelector('[data-wf-faq-search]');
      var status = faq.querySelector('[data-wf-faq-status]');
      var items = Array.prototype.slice.call(faq.querySelectorAll('[data-wf-faq-item]'));
      var groups = faq.querySelectorAll('[data-wf-faq-group]');
      if (!input || !items.length) return;

      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var visible = 0;
        items.forEach(function (item) {
          var match = !query || item.textContent.toLowerCase().indexOf(query) !== -1;
          item.hidden = !match;
          if (match) {
            visible += 1;
            if (query) item.open = true;
          }
        });
        groups.forEach(function (group) {
          group.hidden = !group.querySelector('[data-wf-faq-item]:not([hidden])');
        });
        if (status) status.textContent = query ? visible + ' matching question' + (visible === 1 ? '' : 's') : 'Showing all questions';
      });
    });
  }

  function initBriefBuilder(root) {
    root.querySelectorAll('[data-wf-brief-builder]').forEach(function (builder) {
      if (builder.dataset.wfReady === 'true') return;
      builder.dataset.wfReady = 'true';

      var fields = Array.prototype.slice.call(builder.querySelectorAll('[data-wf-brief-field]'));
      var summary = builder.querySelector('[data-wf-brief-summary]');
      var apply = builder.querySelector('[data-wf-brief-apply]');
      var status = builder.querySelector('[data-wf-brief-status]');
      var storageKey = 'wf_project_brief_v2';

      function selections() {
        var selected = {};
        fields.forEach(function (field) {
          selected[field.dataset.wfBriefField] = field.value;
        });
        return selected;
      }

      function briefText(formRoot) {
        var selected = selections();
        var lines = [
          'Project brief',
          'Inquiry context: ' + (builder.dataset.wfContextType || 'Page') + ' — ' + (builder.dataset.wfContextTitle || document.title),
          'Source page: ' + (builder.dataset.wfContextUrl || window.location.href),
          'Buyer role: ' + selected.role,
          'Project stage: ' + selected.stage,
          'Installation environment: ' + selected.environment,
          'Initial quantity: ' + selected.quantity,
          'Destination region: ' + selected.region,
          'Target launch timing: ' + selected.timing
        ];
        var machineFormat = formRoot && formRoot.querySelector('.wf-machine-format-select');
        if (machineFormat && machineFormat.value) lines.push('Machine format of interest: ' + machineFormat.value);
        return lines.join('\n');
      }

      function updateSummary() {
        var selected = selections();
        if (summary) {
          summary.textContent = [selected.role, selected.stage, selected.environment, selected.quantity].join(' · ');
        }
        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(selected));
        } catch (error) {
          // The builder remains fully usable when browser storage is blocked.
        }
      }

      try {
        var restored = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
        fields.forEach(function (field) {
          var value = restored[field.dataset.wfBriefField];
          var exists = Array.prototype.some.call(field.options, function (option) { return option.value === value; });
          if (exists) field.value = value;
        });
      } catch (error) {
        // Ignore malformed or unavailable session storage.
      }

      fields.forEach(function (field) {
        field.addEventListener('change', function () {
          updateSummary();
          if (status) status.textContent = 'Selections updated. Add the brief when ready.';
        });
      });

      if (apply) {
        apply.addEventListener('click', function () {
          var section = builder.closest('#weimi-inquiry') || document;
          var formRoot = section.querySelector('.form-crm-root');
          var text = briefText(formRoot);
          var message = formRoot && formRoot.querySelector('textarea');

          if (message) {
            var previous = builder.dataset.wfAppliedBrief || '';
            var current = message.value || '';
            var next;
            if (previous && current.indexOf(previous) !== -1) {
              next = current.replace(previous, text);
            } else {
              next = current.trim() ? current.replace(/\s+$/, '') + '\n\n' + text : text;
            }

            var descriptor = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value');
            if (descriptor && descriptor.set) descriptor.set.call(message, next);
            else message.value = next;
            message.dispatchEvent(new Event('input', { bubbles: true }));
            message.dispatchEvent(new Event('change', { bubbles: true }));
            builder.dataset.wfAppliedBrief = text;
            message.focus({ preventScroll: true });
            if (status) status.textContent = 'Brief added. Review the message before submitting.';
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
              if (status) status.textContent = 'Brief copied. Paste it into the project message field.';
            }).catch(function () {
              if (status) status.textContent = 'The form is still loading. Please try again in a moment.';
            });
          } else if (status) {
            status.textContent = 'The form is still loading. Please try again in a moment.';
          }

          analyticsEvent('wf_project_brief_apply', {
            cta_type: 'inquiry',
            module_name: 'inquiry_form',
            interaction_value: 'brief_added'
          });
        });
      }

      updateSummary();
    });
  }

  function analyticsStorageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function analyticsStorageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Tracking must never interfere with browsing when storage is blocked.
    }
  }

  function analyticsPath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function analyticsPageType() {
    var main = document.querySelector('#MainContent[data-template]');
    return analyticsToken(main && main.dataset.template, 'unknown');
  }

  function analyticsToken(value, fallback) {
    var token = String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 64);
    return token || fallback;
  }

  function analyticsModule(element) {
    var container = element && element.closest('[data-wf-context], section, header, footer, aside, main');
    if (!container) return 'sitewide';

    if (container.dataset.wfContext) return analyticsToken(container.dataset.wfContext, 'sitewide');

    var heading = container.querySelector('h1, h2');
    if (heading && heading.textContent.trim()) return analyticsToken(heading.textContent, 'content_section');

    var specificClass = Array.prototype.find.call(container.classList || [], function (className) {
      return className.indexOf('wf-') === 0 && className !== 'wf-band' && className.indexOf('wf-band--') !== 0;
    });
    return analyticsToken(specificClass || container.id, 'content_section');
  }

  function analyticsAttribution() {
    var storageKey = 'wf_attribution_v1';
    var stored = analyticsStorageGet(storageKey);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (error) {
        // Replace malformed or legacy session data with the safe schema below.
      }
    }

    var parameters = new URLSearchParams(window.location.search || '');
    var referrerHost = 'direct';
    try {
      if (document.referrer) referrerHost = new URL(document.referrer).hostname.replace(/^www\./, '');
    } catch (error) {
      referrerHost = 'direct';
    }

    var attribution = {
      traffic_source: analyticsToken(parameters.get('utm_source') || referrerHost, 'direct'),
      traffic_medium: analyticsToken(parameters.get('utm_medium') || (referrerHost === 'direct' ? 'none' : 'referral'), 'none'),
      campaign_name: analyticsToken(parameters.get('utm_campaign'), 'not_set'),
      referrer_host: analyticsToken(referrerHost, 'direct'),
      landing_path: analyticsPath().slice(0, 120)
    };
    analyticsStorageSet(storageKey, JSON.stringify(attribution));
    return attribution;
  }

  function analyticsEvent(name, parameters) {
    if (!window.__weimiAnalyticsEnabled) return;

    var attribution = analyticsAttribution();
    var payload = {
      event: name,
      event_version: '2',
      page_path: analyticsPath(),
      page_type: analyticsPageType(),
      cta_type: analyticsToken(parameters && parameters.cta_type, 'not_applicable'),
      module_name: analyticsToken(parameters && parameters.module_name, 'sitewide'),
      interaction_value: analyticsToken(parameters && parameters.interaction_value, 'not_applicable'),
      traffic_source: attribution.traffic_source,
      traffic_medium: attribution.traffic_medium,
      campaign_name: attribution.campaign_name,
      referrer_host: attribution.referrer_host,
      landing_path: attribution.landing_path
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.__weimiGa4Configured && typeof window.gtag === 'function') {
      var ga4Payload = Object.assign({}, payload);
      delete ga4Payload.event;
      window.gtag('event', name, ga4Payload);
    }
  }

  function analyticsOnce(key, callback, persistForSession) {
    window.__weimiAnalyticsEvents = window.__weimiAnalyticsEvents || {};
    if (window.__weimiAnalyticsEvents[key]) return;
    if (persistForSession && analyticsStorageGet(key)) return;

    window.__weimiAnalyticsEvents[key] = true;
    if (persistForSession) analyticsStorageSet(key, '1');
    callback();
  }

  function analyticsCtaType(link) {
    if (link.dataset.wfCta) return analyticsToken(link.dataset.wfCta, 'navigation');

    var href = link.getAttribute('href') || '';
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return 'navigation';
    }

    if (link.closest('.wf-patent-card')) return 'certificate';
    if (url.hash === '#weimi-inquiry' || url.pathname === '/pages/contact') return 'inquiry';
    if (url.hash === '#CollectionProductGrid' || url.pathname.indexOf('/collections') === 0) return 'system_compare';
    if (url.hostname.indexOf('google.') !== -1 && url.pathname.indexOf('/maps') !== -1) return 'location';
    if (url.origin !== window.location.origin) return 'external_resource';
    if (url.hash && url.pathname === window.location.pathname) return 'section_jump';
    return 'navigation';
  }

  function initAnalytics(root) {
    if (!window.__weimiAnalyticsEnabled || root !== document || document.documentElement.dataset.wfAnalyticsReady === 'true') return;
    document.documentElement.dataset.wfAnalyticsReady = 'true';

    var main = document.querySelector('#MainContent[data-template]');
    if (main && main.dataset.template === 'product') {
      analyticsOnce('wf_product_view:' + analyticsPath(), function () {
        analyticsEvent('wf_product_view', { cta_type: 'product', module_name: 'product_detail' });
      }, false);
    }

    document.addEventListener('click', function (event) {
      var interactive = event.target.closest('[data-wf-chip], [data-wf-tab], [data-wf-resource-filter], [data-wf-gallery-prev], [data-wf-gallery-next]');
      if (interactive) {
        var interactionName = 'content_control';
        var interactionValue = 'control';
        if (interactive.matches('[data-wf-chip]')) {
          interactionName = 'wf_configurator_use';
          interactionValue = interactive.dataset.wfGroup || 'option';
        } else if (interactive.matches('[data-wf-tab]')) {
          interactionName = 'wf_tab_view';
          interactionValue = interactive.dataset.wfTab || 'tab';
        } else if (interactive.matches('[data-wf-resource-filter]')) {
          interactionName = 'wf_resource_filter';
          interactionValue = interactive.dataset.wfResourceFilter || 'filter';
        } else if (interactive.matches('[data-wf-gallery-prev], [data-wf-gallery-next]')) {
          interactionName = 'wf_gallery_use';
          interactionValue = interactive.matches('[data-wf-gallery-next]') ? 'next' : 'previous';
        }
        var interactionKey = [interactionName, analyticsPath(), analyticsModule(interactive), interactionValue].join(':');
        analyticsOnce(interactionKey, function () {
          analyticsEvent(interactionName, {
            cta_type: 'content_interaction',
            module_name: analyticsModule(interactive),
            interaction_value: interactionValue
          });
        }, false);
      }

      var link = event.target.closest('a[href]');
      if (!link || !link.matches('.wf-btn, .wf-text-link, .wf-mobile-quote, .wf-floating-tools__quote, .wf-floating-tools__icon[href], a[href="#weimi-inquiry"], .wf-patent-card a')) return;

      var ctaType = analyticsCtaType(link);
      var moduleName = analyticsModule(link);
      analyticsEvent('wf_cta_click', { cta_type: ctaType, module_name: moduleName });

      if (ctaType === 'system_compare') {
        analyticsEvent('wf_system_compare', { cta_type: ctaType, module_name: moduleName });
      }
      if (ctaType === 'certificate') {
        analyticsEvent('wf_certificate_open', { cta_type: ctaType, module_name: moduleName });
      }
      if (ctaType === 'external_resource') {
        analyticsEvent('wf_external_proof_open', { cta_type: ctaType, module_name: moduleName });
      }
    }, true);

    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!details.matches || !details.matches('details') || !details.open) return;
      if (!details.closest('.wf-accordion, [data-wf-faq]')) return;
      var summary = details.querySelector('summary');
      var questionKey = analyticsToken(summary && summary.textContent, 'question');
      analyticsOnce(['wf_faq_open', analyticsPath(), questionKey].join(':'), function () {
        analyticsEvent('wf_faq_open', {
          cta_type: 'content_interaction',
          module_name: analyticsModule(details),
          interaction_value: questionKey
        });
      }, false);
    }, true);

    document.addEventListener('input', function (event) {
      if (!event.target.closest || !event.target.closest('[data-wf-roi]')) return;
      analyticsOnce('wf_roi_use:' + analyticsPath(), function () {
        analyticsEvent('wf_roi_use', {
          cta_type: 'calculator',
          module_name: analyticsModule(event.target)
        });
      }, false);
    }, true);

    var engagementReady = false;
    var engaged = function () {
      if (!engagementReady) return;
      if (document.visibilityState && document.visibilityState !== 'visible') return;
      analyticsOnce('wf_page_engaged:' + analyticsPath(), function () {
        analyticsEvent('wf_page_engaged', { cta_type: 'engagement', module_name: 'page' });
      }, false);
    };
    window.setTimeout(function () {
      engagementReady = true;
      engaged();
    }, 15000);
    document.addEventListener('visibilitychange', engaged);

    var recordScrollDepth = function () {
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var depth = Math.min(100, Math.round(((window.scrollY || document.documentElement.scrollTop) / scrollable) * 100));
      [50, 90].forEach(function (threshold) {
        if (depth < threshold) return;
        analyticsOnce(['wf_scroll_depth', analyticsPath(), threshold].join(':'), function () {
          analyticsEvent('wf_scroll_depth', {
            cta_type: 'engagement',
            module_name: 'page',
            interaction_value: threshold + '_percent'
          });
        }, false);
      });
    };
    window.addEventListener('scroll', recordScrollDepth, { passive: true });

    var inquiry = document.querySelector('#weimi-inquiry');
    if (inquiry) {
      var viewKey = 'wf_inquiry_view:' + analyticsPath();
      var recordView = function () {
        analyticsOnce(viewKey, function () {
          analyticsEvent('wf_inquiry_view', { cta_type: 'inquiry', module_name: 'inquiry_form' });
        }, false);
      };

      if ('IntersectionObserver' in window) {
        var inquiryObserver = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          inquiryObserver.disconnect();
          recordView();
        }, { threshold: 0.25 });
        inquiryObserver.observe(inquiry);
      } else {
        recordView();
      }
    }

    var recordStart = function (event) {
      if (!event.target.closest || !event.target.closest('.form-crm-root')) return;
      var startKey = 'wf_inquiry_start:' + analyticsPath();
      analyticsOnce(startKey, function () {
        analyticsEvent('wf_inquiry_start', { cta_type: 'inquiry', module_name: 'inquiry_form' });
      }, true);
    };
    document.addEventListener('focusin', recordStart, true);
    document.addEventListener('input', recordStart, true);

    if (analyticsPath() === '/pages/thank-you') {
      var submitKey = 'wf_inquiry_submit_v2';
      analyticsOnce(submitKey, function () {
        analyticsEvent('wf_inquiry_submit', { cta_type: 'inquiry', module_name: 'thank_you' });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-18126963657/bnLECNK4r-EcEMmHzsND'
          });
        }
      }, true);
    }
  }

  function init(root) {
    initHeader(root);
    initHeroMotion(root);
    initTabs(root);
    initRevenue(root);
    initConfigurator(root);
    initMobileMenu(root);
    initActiveNavigation(root);
    initReveal(root);
    initFloatingTools(root);
    initEcomSendAutoPopup();
    initMediaGallery(root);
    initResourceExplorer(root);
    initMachineFormatSelect(root);
    initFaqSearch(root);
    initBriefBuilder(root);
    initAnalytics(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    observeFormCrm();
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('weimi:analytics-ready', function () { initAnalytics(document); });
})();
